(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairSeminarsController', VirtualFairSeminarsController)

        VirtualFairSeminarsController.$inject = ['$uibModal', '$scope','SellerService' ,'ExpoService', 'VirtualFairService', 'AclService','CountriesNewService', 'TimezonesService','$http', 'API_BASE', '$state','toastr','$stateParams'];


    function VirtualFairSeminarsController( $uibModal, $scope, SellerService, ExpoService, VirtualFairService, AclService, CountriesNewService, TimezonesService, $http, API_BASE, $state, toastr, $stateParams) {
        var vm = this;

        vm.seminars              = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.expo                  = '';
        vm.expoSelected          = '';

        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.active                = [{name:'All',value:'All'}, {name:'Yes', value:1}, {name:'No', value:0}];
        vm.activeSelected        = {name:'Yes', value:1};
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.deleteSeminar         = deleteSeminar;
        vm.countResult           = 0;
        vm.registersInEventSelected = {name:'No', id:0};
        vm.registersInEventList = [{id:'all', name:'All'},{id:1, name:'Yes'},{id:0,name:'No'}];


        function activate() {
            if ($stateParams.hasOwnProperty('msg') && $stateParams.msg) {
                if ($stateParams.error) {
                    toastr.error(`${$stateParams.msg}`);
                } else {
                    toastr.success(`${$stateParams.msg}`);
                }
                
            }
            vm.selectExpo();
            vm.getByFilter()
        }

        function selectExpo () {
            ExpoService.getExposVirtualFair().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function deleteSeminar(seminar) {
            alertify.confirm(
                'Delete Seminar',
                `Do you really want to delete this <strong>${seminar.title}</strong>?`,
                function () {
                    VirtualFairService.deleteSeminar(seminar.id)
                        .then(function (response) {
                            if(response.success) {
                                vm.getByFilter();
                                alertify.success('Seminar successfull deleted!');
                            } else {
                                alertify.error(response.msg);
                            }
                        });
                },
                function () {
                    return true;
                }
            );
        }

        function getByFilter() {
            vm.query = {
                virtual_fair_id: vm.expoSelected.id
            };


            VirtualFairService.getByFilterSeminar(vm.query).then(function(response){
                vm.seminars = response.data;
                vm.queryFlag       = true;
                vm.countResult     = Object.keys(response.data).length;
            }).catch(function(err) {

            });
        }

        activate();
    }

})();